import axios from '@/shared/utils/axios-init';
import filterPagesByUrl from '@/shared/utils/helpers/filterPagesByUrl';
import sortPagesByCateg from '@/shared/utils/helpers/sortPagesByCateg';

/*eslint-disable*/

const initialState = {
  document: '',
  pages: {},
  errorAlert: false,
  loading: true,
  navOpen: false,
};

const getters = {
  getDocument: state => state.document,
  getPages: state => state.pages,
  getErrorAlert: state => state.errorAlert,
  getLoading: state => state.loading,
  getNavOpen: state => state.navOpen,
};

const actions = {
  async fetchCurrentPage({ commit }, keyword) {
    commit('setErrorAlert', false);
    commit('setLoading', true);

    try {
      const lang = localStorage.getItem('language');
      const { data } = await axios.post('/page', { lang, keyword });

      if (data.page) {
        commit('setDocument', data.page.content);
      } else {
        commit('setErrorAlert', true);
      }
    } catch (e) {
      console.log(e);
    } finally {
        commit('setLoading', false);
    }
  },
  async fetchPages({ commit }) {
    try {
      const lang = localStorage.getItem('language');
      const { data } = await axios.post('/pages', { lang });

      const faqPages = filterPagesByUrl(data.pages, 'faq');
      const faqPagesByCategs = sortPagesByCateg(faqPages);

      commit('setPages', faqPagesByCategs);
    } catch (e) {
      console.log(e);
    }
  },
};

const mutations = {
  setDocument(state, payload) {
    state.document = payload;
  },
  setPages(state, payload) {
    state.pages = payload;
  },
  setErrorAlert(state, payload) {
    state.errorAlert = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setNavOpen(state, payload) {
    state.navOpen = payload;
  },
};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/Faq/modules/index.js